<template>
  <div :class="accordionClass">
    <p v-if="errorMessage">{{errorMessage}}</p>
    <p v-else-if="tangens.length===0">単元がありません</p>
    <p v-else-if="tangens.length>=1">（※複数選択可）</p>

    <!-- 単元一覧 -->
    <ul class="accordion-list" v-if="!errorMessage && tangens.length !== 0">
      <li class="item parnet-item" v-for="(tangen, index) in tangens"
        :key="index"
      >
        <div class="parent-item-wrap">
          <button
            v-if="tangen.children.length !== 0 "
            :disabled="tangen.disabledFlag"
            type="button"
            class="plus-btn mr-1 js-accordion-toggle"
            @click="showChildren(tangen, index, 'show')">
            ＋
          </button>

          <v-checkbox
            :disabled="tangen.disabledFlag"
            :input-value="tangen.isAllSelected"
            @change="setTangen(tangen, index, 'checkAll')"
            color="secondary"
            :label="tangen.text"
            hide-details
            dense
            style="max-height: 35px"
          />
        </div>
        <ul class="child-list" v-if="tangen.isShow">
          <li class="item child-item py-2" v-for="(child, childIndex) in tangen.children"
            :key="childIndex"
          >
            <v-checkbox
              color="secondary"
              :label="child.text"
              :input-value="child.checked"
              @change="setTangen(tangen, index, 'check', childIndex)"
              hide-details
              dense
            />
          </li>
        </ul>
      </li>
    </ul>

  </div>
</template>

<script>
export default {
  computed: {
    accordionClass() {
      return [{
        'accordion-wrap': !this.errorMessage && this.tangens.length !== 0
      }]
    },
    tangens() {
      return this.$store.state.conditions.selectedQuestionRangeTangen
        .filter(unit => unit.gradeId == this.$store.state.conditions.selectedGrade)
        .filter(unit => unit.publisherId == this.$store.state.conditions.selectedTextbook)
        // ゲットスルーのテーマ別単元選択、['Group 1', 'Group 2', 'Group 3', 'Group 4', 'Group 5']は隠し球として取っておくため非表示
        .filter(unit => !['Group 1', 'Group 2', 'Group 3', 'Group 4', 'Group 5'].includes(unit.text))
    },
    errorMessage() {
      let errorItems = []
      if (!this.$store.state.conditions.selectedGrade) errorItems.push('学年')
      if (!this.$store.state.conditions.selectedTextbook) errorItems.push('準拠')
      return errorItems.length !== 0 ?
        errorItems.join('と') + 'を選択してください。'
        : ''
    }
  },


  methods: {
    showChildren(tangen, index) {
      this.$store.commit('conditions/setSelectedQuestionRangeTangen', {
        index: index,
        value: tangen.value,
        params: {
          isShow: !this.tangens[index].isShow
        }
      })
    },
    setTangen(tangen, index, mode, childIndex = null) {
      let show = this.tangens[index].isShow
      let isAllSelected = this.tangens[index].isAllSelected
      if(mode === 'checkAll') isAllSelected = !this.tangens[index].isAllSelected     //isAllSelectedを切り替える
      const tangenData = {
        index: index,
        value: tangen.value,
        mode: mode,
        params: {
          isShow: show,
          isAllSelected: isAllSelected,
        }
      }
      if(mode === 'check') {
        tangenData.childIndex = childIndex,
        tangenData.checked = !this.tangens[index].children[childIndex].checked
      }
      this.$store.commit('conditions/setSelectedQuestionRangeTangen', tangenData)
    },
  }
}
</script>

<style lang="stylus" scoped>
  .allotaion-area
    width 200px

  .flexbox
    display: flex;
    flex-wrap: nowrap;

  .accordion-wrap
    width: 500px;
    height: 300px;
    overflow-x: hidden;
    overflow-y: scroll;

  .accordion-list
    list-style-type: none;
    padding: 0;

  .accordion-list .v-input--selection-controls
    margin-top: 0;

  .accordion-list .parent-item
    border-bottom: 1px solid #ccc;

  .parent-item-wrap
    background: #efefef;
    padding: 1em 0 1em 1em;
    display: flex;
    flex-wrap: nowrap;
    align-items: flex-end;

  .accordion-list .item
    border-bottom: 1px solid #ccc;

  .child-list
    list-style-type: none;
    padding: 0;

  .child-list.is_open
    height: auto;
    opacity: 1;

  .child-item
    padding: 1em 0 1em 2.95em;

  .plus-btn
    box-sizing: border-box;
    font-weight bold
    text-align center
    padding 2px 0;
    margin: 0;
    width: 2em;
    border-radius 3px
    cursor pointer
    position relative
    position: relative;
    color: #fff;
    background-color: #aaa;
    font-size: 0.8em;

  .button__disabled
    background: #717171;
    color: #655e5e;
</style>
